module.exports = __webpack_public_path__ + "media/unipod/kitchen-pod-card-picture-d55c49a2.jpg";